export default {
	wrapper: {
		position: 'relative',
		minHeight: '70vh',
		height: '100%',
		width: '100% !important',
		margin: '0 !important',
	},
	loadingIndicatorWrapper: {
		position: 'absolute',
		left: '50%',
		top: '50%',
		transform: 'translate(-50%, -50%)',
	},
	noResultsFound: {
		flex: '1',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		color: '#aaa',
		fontSize: '14px',
		minHeight: '50vh',
	},
	dateTimeWrapper: {
		'& .rdtPicker': {
			top: '65px',
			zIndex: 10,
		},
	},
	downloadReport: {
		marginTop: '27px',
	}
};
